import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const KeyAchievements = () => {
  return (
    <section id="key-achievements" className="py-16 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-bold text-white">Key Achievements</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {portfolioData.keyAchievements.map((achievement, index) => (
            <motion.article
              key={achievement}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
              whileHover={{
                y: -6,
                boxShadow: "0 0 26px rgba(34, 211, 238, 0.22)",
                borderColor: "rgba(103, 232, 249, 0.7)",
              }}
              className="rounded-2xl border border-slate-700/60 bg-slate-900/60 p-6"
            >
              <p className="text-sm leading-relaxed text-slate-200">{achievement}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyAchievements;
